<template>
  <div class="blog-page">
    <container>
      <rotate-square6 v-if="this.loading"></rotate-square6>
      <div v-if="!this.loading" class="blog-page__posts">
        <div v-for="post in posts" :key="post.id" class="blog-page__post">
          <div class="blog-page__post-thumb">
            <div class="blog-page__post-thumb-inner">
              <router-link :to="{ name: 'post', params: { slug: post.slug } }">
                <img
                  class="blog-page__post-image"
                  :src="
                    post.featured_media
                      ? post._embedded[
                          'wp:featuredmedia'
                        ][0].source_url.substring(
                          0,
                          post._embedded[
                            'wp:featuredmedia'
                          ][0].source_url.lastIndexOf('.')
                        ) +
                        '-360x360' +
                        post._embedded[
                          'wp:featuredmedia'
                        ][0].source_url.substring(
                          post._embedded[
                            'wp:featuredmedia'
                          ][0].source_url.lastIndexOf('.')
                        )
                      : require('@/assets/images/thumb.png')
                  "
                  alt
                />
              </router-link>
            </div>
          </div>
          <p class="blog-page__post-info">
            Postado em {{ parseDate(post.date) }}
          </p>
          <h2 class="blog-page__post-title">
            <router-link :to="{ name: 'post', params: { slug: post.slug } }">
              <span v-html="post.title.rendered"></span>
            </router-link>
          </h2>
          <ButtonBox
            outline
            size="small"
            class="blog-page__post-button"
            :to="{ name: 'post', params: { slug: post.slug } }"
            >Leia</ButtonBox
          >
        </div>
      </div>
      <div class="blog-page__more">
        <ButtonBox v-if="finished" :disabled="loading2" outline @click="more"
          >Ver Mais Postagens</ButtonBox
        >
      </div>
    </container>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import RotateSquare6 from "vue-loading-spinner/src/components/RotateSquare6";

import Container from "@/components/Container";
import ButtonBox from "@/components/ButtonBox";

export default {
  name: "posts",
  components: {
    Container,
    ButtonBox,
    RotateSquare6
  },
  data: () => ({
    loading: false,
    loading2: false
  }),
  methods: {
    ...mapActions("posts", ["next", "rewind", "all", "loadMore"]),
    parseDate(date) {
      return new Date(date).toLocaleDateString();
    },
    async more() {
      this.loading2 = true;
      await this.loadMore();
      await this.next();

      this.loading2 = false;
    }
  },
  computed: {
    ...mapState("posts", {
      posts: "list"
    }),
    ...mapGetters("posts", ["finished"])
  },
  async created() {
    // await this.rewind();
    this.loading = true;
    this.loading2 = true;
    await this.next();
    this.loading = false;
    this.loading2 = false;
  },
  head: {
    title: {
      inner: "Blog sobre estratégias de comunicação e marketing "
    },

    meta: [
      {
        name: "description",
        content:
          "O Blog da Magor reúne artigos sobre temas relevantes em comunicação e marketing e alguns cases executados pela nossa equipe. Confira!",
        id: "desc"
      },
      {
        name: "og:description",
        content:
          "O Blog da Magor reúne artigos sobre temas relevantes em comunicação e marketing e alguns cases executados pela nossa equipe. Confira!",
        id: "ogdesc"
      },
      {
        name: "keywords",
        content:
          "magor, design, gráfico, digital, propaganda, marketing, talento"
      }
    ]
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/vars";

.blog-page {
  padding-top: 11.5rem;
  @media (max-width: $max-sm) {
    padding-top: 1rem;
  }

  &__posts {
    display: grid;

    gap: 4rem;

    @media (min-width: $min-md) {
      gap: 15rem;
    }
  }

  &__post {
    display: grid;

    // margin: 4rem 0;
    padding: 1.8rem 0;

    grid-template-rows: repeat(2, auto);
    grid-template-columns: 1fr 2fr;

    gap: 1.8rem;

    @media (min-width: $min-md) {
      // margin: 15rem 0;
      padding: 0;

      grid-template-rows: 1.8rem auto 5.8rem;

      gap: 3rem;
    }
  }

  &__post-thumb {
    grid-row: 1 / -1;
  }

  &__post-thumb-inner {
    height: 100%;

    @media (max-width: $max-sm) {
      margin: -1.8rem 0 -1.8rem -4rem;
    }
  }

  &__post-image {
    width: 100%;
    height: 100%;

    border-radius: 0.9rem;

    object-fit: cover;
  }

  &__post-info {
    font-size: 1.5rem;
    font-weight: 900;
    line-height: 1.2;

    @media (max-width: $max-sm) {
      display: none;
    }
  }

  &__post-title {
    font-size: 1.7rem;
    font-weight: 900;
    line-height: 1.2;

    @media (min-width: $min-md) {
      font-size: 6rem;
    }

    a {
      font: inherit;

      text-decoration: none;

      color: inherit;
    }
  }

  &__post-button {
    justify-self: start;
    @media (max-width: $max-sm) {
      display: none;
    }
  }

  &__more {
    height: 37.5rem;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: $max-sm) {
      height: 10.5rem;
    }
  }

  &__more-button {
    font-size: 1.8rem;
    font-weight: 700;
    line-height: 1;

    padding: 1.5rem 0 1.5rem 4.4rem;

    color: #737373;
    background-image: url("../assets/icons/coffe.svg");
    background-repeat: no-repeat;
    background-size: 3.1rem 3.3rem;
  }
}
</style>
